// Register of all events
// Global events uses the format(Global keyword underscore event name) e.g. [Global_EventName]
// Component events uses the format(component name underscore event name) e.g. [ComponentName_EventName]
export const AdvancedLocalePicker_addAllLocales = 'AdvancedLocalePicker_addAllLocales';
export const LabelView_addAllLocales = 'LabelView_addAllLocales';
//FolderMetaDataDialog Events
export const FolderMetaDataDialog_changeLabels = 'FolderMetaDataDialog_changeLabels';
export const FolderMetaDataDialog_changeLocales = 'FolderMetaDataDialog_changeLocales';
export const FolderMetaDataDialog_changeVersion = 'FolderMetaDataDialog_changeVersion';
export const FolderMetaDataDialog_changeComment = 'FolderMetaDataDialog_changeComment';
export const FolderMetaDataDialog_changeDateValidFrom = 'FolderMetaDataDialog_changeDateValidFrom';
export const FolderMetaDataDialog_changeDateValidTo = 'FolderMetaDataDialog_changeDateValidTo';
export const FolderMetaDataDialog_changeTags = 'FolderMetaDataDialog_changeTags';
export const FolderMetaDataDialog_changeRoles = 'FolderMetaDataDialog_changeRoles';
export const FolderMetaDataDialog_changeOwnerRoles = 'FolderMetaDataDialog_changeOwnerRoles';
export const FolderMetaDataTabMain_changeLabels = 'FolderMetaDataTabMain_changeLabels';
export const FolderMetaDataTabLocales_changeLocales = 'FolderMetaDataTabLocales_changeLocales';
//FileMetaDataDialog Events
export const FileMetaDataDialog_changeLabels = 'FileMetaDataDialog_changeLabels';
export const FileMetaDataDialog_changeLocales = 'FileMetaDataDialog_changeLocales';
export const FileMetaDataDialog_changeVersion = 'FileMetaDataDialog_changeVersion';
export const FileMetaDataDialog_changeComment = 'FileMetaDataDialog_changeComment';
export const FileMetaDataDialog_changeDateValidFrom = 'FileMetaDataDialog_changeDateValidFrom';
export const FileMetaDataDialog_changeDateValidTo = 'FileMetaDataDialog_changeDateValidTo';
export const FileMetaDataDialog_changeTags = 'FileMetaDataDialog_changeTags';
export const FileMetaDataDialog_changeWatermark = 'FileMetaDataDialog_changeWatermark';
export const FileMetaDataDialog_changePublicAccess = 'FileMetaDataDialog_changePublicAccess';
export const FileMetaDataDialog_changeRoles = 'FileMetaDataDialog_changeRoles';
export const FileMetaDataDialog_changeOwnerRoles = 'FileMetaDataDialog_changeOwnerRoles';
export const FileMetaDataDialog_changeUserLabels = 'FileMetaDataDialog_changeUserLabels';
export const FileMetaDataDialog_changeDisclaimer = 'FileMetaDataDialog_changeDisclaimer';
export const FileMetaDataDialog_changeImage = 'FileMetaDataDialog_changeImage';
export const FileMetaDataTabMain_changeLabels = 'FileMetaDataTabMain_changeLabels';
export const FileMetaDataTabLocales_changeLocales = 'FileMetaDataTabLocales_changeLocales';
